export function isPayosDebugEnabled(): boolean {
    // Debug logs are intentionally disabled.
    return false;
}

export function payosDebugLog(event: string, details?: Record<string, unknown>) {
    void event;
    void details;
}

export function payosDebugWarn(event: string, details?: Record<string, unknown>) {
    void event;
    void details;
}

export function payosDebugError(event: string, details?: Record<string, unknown>) {
    void event;
    void details;
}
